import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const url = "https://api.singledebt.in";

export const getToken = createAsyncThunk("token/getToken", async () => {
  try {
    const res = await axios.get(`${url}/token`);
    return res.data.token[0].token;
  } catch (error) {
    throw error;
  }
});

const tokenSlice = createSlice({
  name: "token",
  initialState: {
    token: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getToken.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload;
      })
      .addCase(getToken.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch token";
      });
  },
});

export default tokenSlice.reducer;
